import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    Injector,
  } from '@angular/core';
import { BaseRoute } from '../../shared/components/base.route';
import { ApplicationActions } from '../../actions/application.actions';
import { SelectOptionsService } from '../../shared/services/selectoptions.service';
@Component({
  selector: 'md-edit-personal-info-modal',
  template: require('./edit-personal-info-modal.component.html'),
  styles: [require('./edit-personal-info-modal.component.scss')],
})

export class EditPersonalInfoModalComponent extends BaseRoute {
  @ViewChild('form') formElement;
  @Input() formData;
  @Output() closeEmitter = new EventEmitter();
  formIsValid = false;

  checkedButMailingEmpty = false;

  constructor(
    injector: Injector,
    appActions: ApplicationActions,
    optionsService: SelectOptionsService) {
    super(injector);
    this.appActions = appActions;
    this.optionsService = optionsService;
    this.formIsValid = false;
    this.checkedButMailingEmpty = false;
  }

  ngOnInit() {
    this.form = this.formData;

    this.mobilePhoneOriginal = this.appActions.getData(
      'PersonalInformation.mobilePhone',
      ''
    );
    this.emailOriginal = this.appActions.getData('YourInformation.email', '');
    this.streetOriginal = this.appActions.getData(
        'PersonalInformation.address.street',
        ''
      );
    this.street2Original = this.appActions.getData(
        'PersonalInformation.address.street2',
        ''
      );
    this.cityOriginal = this.appActions.getData(
        'PersonalInformation.address.city',
        ''
      );
    this.stateOriginal = this.appActions.getData(
        'PersonalInformation.address.state',
        ''
      );
    this.zipOriginal = this.appActions.getData(
        'PersonalInformation.address.zip',
        ''
      );
    if (this.zipOriginal.indexOf('-') >= 0) {
      this.zipOriginal = this.zipOriginal.substring(0, this.zipOriginal.indexOf('-'));
      this.appActions.setData('PersonalInformation.address.zip', this.zipOriginal);
    }

    this.mailingStreetOriginal = this.appActions.getData(
        'PersonalInformation.mailingAddress.street',
        ''
      );
    this.mailingStreet2Original = this.appActions.getData(
        'PersonalInformation.mailingAddress.street2',
        ''
      );
    this.mailingCityOriginal = this.appActions.getData(
        'PersonalInformation.mailingAddress.city',
        ''
      );
    this.mailingStateOriginal = this.appActions.getData(
      'PersonalInformation.mailingAddress.state',
      ''
    );
    this.mailingZip = this.appActions.getData(
      'PersonalInformation.mailingAddress.zip',
      ''
    );
    if (this.mailingZip.indexOf('-') >= 0) {
      this.mailingZip = this.mailingZip.substring(0, this.mailingZip.indexOf('-'));
      this.appActions.setData('PersonalInformation.mailingAddress.zip', this.mailingZip);
    }

    this.mailAddressDifferentOriginal = this.appActions.getData(
      'PersonalInformation.mailAddressDifferent',
      ''
    );
    if (this.mailingStreetOriginal.length === 0) {
      this.defaultMailingAddressToHome();
    }
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  checkValue(value) {
    if (
        value === null ||
        value === undefined ||
        (value && Object.keys(value).length === 0)
      ) {
      return '';
    } else {
      return value;
    }
  }

  btnClick(e) {
    this.mailAddressDifferentClosing = this.appActions.getData(
      'PersonalInformation.mailAddressDifferent',
      ''
    );
    this.mailingStreetClosing = this.appActions.getData(
      'PersonalInformation.mailingAddress.street',
      ''
    );
    this.mailingCityClosing = this.appActions.getData(
      'PersonalInformation.mailingAddress.city',
      ''
    );
    this.mailingStateClosing = this.appActions.getData(
      'PersonalInformation.mailingAddress.state',
      ''
    );
    this.mailingZipClosing = this.appActions.getData(
      'PersonalInformation.mailingAddress.zip',
      ''
    );

    if (e.action === 'close') {
      this.appActions.setData(
        'PersonalInformation.mailAddressDifferent',
        this.mailAddressDifferentOriginal
      );
      this.appActions.setData(
          'PersonalInformation.mobilePhone',
          this.checkValue(this.mobilePhoneOriginal)
        );
      this.appActions.setData(
        'YourInformation.email',
        this.checkValue(this.emailOriginal)
      );
      this.appActions.setData(
          'PersonalInformation.address.street',
          this.checkValue(this.streetOriginal)
        );
      this.appActions.setData(
          'PersonalInformation.address.street2',
          this.checkValue(this.street2Original)
        );
      this.appActions.setData(
          'PersonalInformation.address.city',
          this.checkValue(this.cityOriginal)
        );
      this.appActions.setData(
          'PersonalInformation.address.state',
          this.checkValue(this.stateOriginal)
        );
      this.appActions.setData(
        'PersonalInformation.address.zip',
        this.checkValue(this.zipOriginal)
      );

      if (this.mailingStreetOriginal.length === 0 && this.mailingStreetClosing.length === 0) {
        this.defaultMailingAddressToHome();
      } else {
        this.restoreMailingAddressToPrevious();
      }

      if (this.mailAddressDifferentClosing === true && this.mailingStreetClosing.length === 0) {
        this.formIsValid = false;
        this.checkedButMailingEmpty = true;
      } else {
        this.formIsValid = true;
        this.checkedButMailingEmpty = false;
      }

      this.closeEmitter.emit();
      return;
    } else {

      this.countInputs = Object.values(this.formElement.isValidMap).length;
      this.validInputs = 0;

      // eslint-disable-next-line no-unused-expressions
      this.formElement &&
          Object.values(this.formElement.isValidMap).map((e) => {
            this.validInputs += e === true ? 1 : 0;
            return this.validInputs;
          });

      if (this.validInputs === this.countInputs) {
        this.formIsValid = true;
      } else {
        this.formIsValid = false;
      }

      if (this.streetOriginal.toLowerCase().trim() === this.mailingStreetClosing.toLowerCase().trim() &&
        this.stateOriginal.toLowerCase().trim() === this.mailingStateClosing.toLowerCase().trim() &&
        this.cityOriginal.toLowerCase().trim() === this.mailingCityClosing.toLowerCase().trim() &&
        this.zipOriginal.toLowerCase().trim() === this.mailingZipClosing.toLowerCase().trim()
      ) {
        this.appActions.setData(
          'PersonalInformation.mailAddressDifferent',
          false
        );
      }

      if (this.mailAddressDifferentClosing === true && this.mailingStreetClosing.length === 0) {
        this.formIsValid = false;
        this.checkedButMailingEmpty = true;
      } else {
        this.formIsValid = true;
        this.checkedButMailingEmpty = false;
      }

      if (!this.mailAddressDifferentClosing) {
        this.defaultMailingAddressToHome();
      }

      if (this.formElement && this.formIsValid) {
        this.closeEmitter.emit();
        if (
          (this.mailingStreetOriginal.length === undefined && this.mailingStreetClosing.length === undefined)
            || this.mailAddressDifferentClosing === false) {
          this.defaultMailingAddressToHome();
        }
        return;
      }
    }
  }

  defaultMailingAddressToHome() {
    this.appActions.setData(
      'PersonalInformation.mailingAddress.street',
      this.checkValue(this.streetOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.street2',
      this.checkValue(this.street2Original)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.city',
      this.checkValue(this.cityOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.state',
      this.checkValue(this.stateOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.zip',
      this.checkValue(this.zipOriginal)
    );
  }

  restoreMailingAddressToPrevious() {
    this.appActions.setData(
      'PersonalInformation.mailingAddress.street',
      this.checkValue(this.mailingStreetOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.street2',
      this.checkValue(this.mailingStreet2Original)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.city',
      this.checkValue(this.mailingCityOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.state',
      this.checkValue(this.mailingStateOriginal)
    );
    this.appActions.setData(
      'PersonalInformation.mailingAddress.zip',
      this.checkValue(this.mailingZip)
    );
  }

  updateOptionValue(event) {
    switch (event.id) {
      // eslint-disable-next-line no-case-declarations
      case 'mobilePhone':
        const formattedPhno = this.phoneNumberMasking(
            event.value.replace(/[^a-z\d\s]+/gi, '')
          );
        this.appActions.setData(
            'PersonalInformation.mobilePhone',
            formattedPhno
          );
        break;
      case 'email':
        this.appActions.setData('PersonalInformation.email', event.value);
        break;
      case 'addressStreet':
        this.appActions.setData(
            'PersonalInformation.address.street',
            event.value
          );
        break;
      case 'addressStreet2':
        this.appActions.setData(
            'PersonalInformation.address.street2',
            event.value
          );
        break;
      case 'addressCity':
        this.appActions.setData(
            'PersonalInformation.address.city',
            event.value
          );
        break;
      case 'addressState': {
        const addressStateCode = this.optionsService.getCode('state', event.value);
        this.appActions.setData(
            'PersonalInformation.address.state',
            addressStateCode
          );
        break;
      }
      case 'addressZip':
        this.appActions.setData(
          'PersonalInformation.address.zip',
          event.value
        );
        break;
      case 'mailingStreet':
        this.appActions.setData(
            'PersonalInformation.mailingAddress.street',
            event.value
          );
        break;
      case 'mailingStreet2':
        this.appActions.setData(
            'PersonalInformation.mailingAddress.street2',
            event.value
          );
        break;
      case 'mailingCity':
        this.appActions.setData(
            'PersonalInformation.mailingAddress.city',
            event.value
          );
        break;
      case 'mailingState': {
        const mailingStateCode = this.optionsService.getCode('state', event.value);
        this.appActions.setData(
            'PersonalInformation.mailingAddress.state',
            mailingStateCode
          );
        break;
      }
      case 'mailingZip':
        this.appActions.setData(
            'PersonalInformation.mailingAddress.zip',
            event.value
          );
        break;
      default:
        // code block
    }
  }

  phoneNumberMasking(value) {
    let maskedInput = value.split('');
    if (maskedInput.length > 2) {
      maskedInput.splice(3, 0, '-');
      if (maskedInput.length > 6) {
        maskedInput.splice(7, 0, '-');
      }
    }
    maskedInput = maskedInput.join('');
    return maskedInput;
  }
}
